import "./style.css";
import ReactDOM from "react-dom/client";
import { Canvas } from "@react-three/fiber";
import Experience from "./Experience.jsx";
import { StrictMode, Suspense } from "react";
import { Grid } from "@react-three/drei";

const root = ReactDOM.createRoot(document.querySelector("#root"));

root.render(
  <StrictMode>
    <Canvas
      flat
      camera={{ fov: 75, position: [0, 12, 0] }}
      eventSource={document.getElementById("root")}
      eventPrefix="client"
      shadows
    >
      <color attach="background" args={["#ffffff"]} />
      <ambientLight intensity={4} />
      <Grid
        position={[0, -1, 0]}
        args={[50, 50]} // size
        cellSize={1} // size of main grid cells
        cellThickness={0.25} // line thickness of main grid
        cellColor="#555555" // color of main grid
        sectionSize={10} // size of secondary grid sections
        sectionThickness={0.5} // line thickness of secondary grid
        sectionColor="#222222" // color of secondary grid
        fadeDistance={30} // distance where grid starts fading
        infiniteGrid // extends grid to horizon
      />
      <Suspense fallback={null}>
        <Experience />
      </Suspense>
    </Canvas>
  </StrictMode>
);
